<div class="config-editor-container has-own-sub-chrome">
    <dashboard-editor-sub-chrome [config]="dashboardEditorSubChromeConfig"></dashboard-editor-sub-chrome>
    <div loading-spin [isLoading]="isPageLoading" [loadingSize]="'big'" class="content">
        <div class="left-box">
            <div class="preview-box preview-box-dashboard">
                <tam-dashboard [options]="dashboardOptions"></tam-dashboard>
            </div>
        </div>
        <div class="right-box">
            <tile-setting-wrapper #tileConfigComp [config]="tileSettingConfig">
            </tile-setting-wrapper>
        </div>
    </div>
</div>